import { render } from "./TakeHomePay.vue?vue&type=template&id=5351a074"
import script from "./TakeHomePay.vue?vue&type=script&lang=js"
export * from "./TakeHomePay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__